import { hydrateRoot, createRoot } from 'react-dom/client';
import './index.css';
import App from './app/App';

const container = document.getElementById('root') as HTMLElement;

if (container.hasChildNodes()) {
    // Если внутри <div id="root"> уже есть HTML (пререндер), используем hydrate
    hydrateRoot(container, App);
} else {
    // Обычный рендер для разработки
    createRoot(container).render(App);
}
